module.exports = __webpack_public_path__ + "static/media/nav_2.80101371.png";